import React from 'react';

const Footer = ({ className = "" }) => {
  return (
    <footer className={`text-center py-2 ${className}`}>
      <p className="text-[#555] text-[10px] sm:text-xs opacity-60">
        Desarrollado por{' '}
        <a 
          href="https://agsoftweb.com.mx" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-[#24b183] hover:text-[#1f9a72] transition-colors"
        >
          Agsoftweb
        </a>
      </p>
    </footer>
  );
};

export default Footer;

